import { createSlice } from "@reduxjs/toolkit";
import { Toastify } from "../../../../components/Toaster";
import { errorSideEffects, loadingSideEffects, successSideEffects, updatingSideEffects } from "../..";
import { getOutcomeTrackingState, getRequestTrackingState, MutationTrackingState } from "../../../../services/analytics/tracking";

export interface SecondFactorAuthentication {
  IsAuthenticatorEnabled?: boolean;
  IsRequired?: boolean;
  IsSecondFactorAuthenticatorEnabled?: boolean;
  errorCode?: string;
  description?: string;
  IsEmailOtpAuthenticatorEnabled?: boolean;
  IsSmsOtpAuthenticatorEnabled?: boolean;
  IsSecurityQuestionAsMFAEnabled?: boolean;
  MinimumSecurityQuestionsToAsk?: number;
  IsPushAuthenticatorEnabled?: boolean;
  IsDuoAuthenticatorEnabled?: boolean;
  IsPasskeyMFAEnabled?: boolean;
}

export interface SecondFactorAuthenticationState {
  Data: SecondFactorAuthentication;
  isLoading: boolean;
  isUpdating: boolean;
  isSuccess: boolean;
  isError: boolean;
  errorMessage: string | null;
}

export const SecondFactorAuthSlice = createSlice({
  name: "secondFactorAuthentication",
  initialState: {
    Data: {},
    isLoading: false,
    isUpdating: false,
    isSuccess: false,
    isError: false,
    errorMessage: null
  },
  reducers: {
    getSecondFactorAuth(state) {
      Object.assign(state, loadingSideEffects);
    },
    getSecondFactorAuthSuccess(state, action) {
      state.Data = action.payload;
      Object.assign(state, successSideEffects);
    },
    getSecondFactorAuthError(state, action) {
      Object.assign(state, errorSideEffects);
      state.errorMessage = action.payload;
    },
    updateSecondFactorAuth(state, action) {
      Object.assign(state, updatingSideEffects, getRequestTrackingState(action));
    },
    updateSecondFactorAuthSuccess(state, action) {
      Object.assign(state, successSideEffects, getOutcomeTrackingState(state as MutationTrackingState, "success"));
      state.Data = action.payload;
      Toastify("success", "MFA updated successfully");
    },
    updateSecondFactorAuthError(state, action) {
      Object.assign(state, errorSideEffects, getOutcomeTrackingState(state as MutationTrackingState, "error"));
      state.errorMessage = action.payload;
      Toastify("error", action.payload);
    }
  }
});

export const { getSecondFactorAuth, getSecondFactorAuthError, getSecondFactorAuthSuccess, updateSecondFactorAuth, updateSecondFactorAuthError, updateSecondFactorAuthSuccess } =
  SecondFactorAuthSlice.actions;

export default SecondFactorAuthSlice.reducer;
